import {connect} from 'react-redux';
import {createSelector} from 'reselect';
import {ProtocolView as Component} from './ProtocolView';
import {fetchProtocolScene} from '@learningblocks/protocol-constants/lib/Utilities';

import {
  setHeldObject,
  setHeld,
  setTargetList,
  pushInteractions,
  setLastDrop,
  setSceneScale,
  setUserScale,
  setupProtocolScene,
  setTaskPages,
  showMoveMenu,
  setModal
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    heldObject: state.notebook.protocolSection.scene.heldObject,
    targetList: state.notebook.protocolSection.scene.targetList,
    interactions: state.notebook.protocolSection.scene.interactions,
    undoAttempts: state.notebook.protocolSection.scene.undo?.attempts,
    solutions: (state.notebook.protocolSection.scene.hasOwnProperty('apparatus'))?state.notebook.protocolSection.scene.apparatus.solutions:null,

    drawerOpen: !state.notebook.notebookCollapsed,
    title: state.notebook.protocolSection.pageTitle,
    sceneType: state.notebook.protocolSection.currentSlide,
    apparatus: state.notebook.protocolSection.apparatus,
    sequence: state.notebook.protocolSection.sequence,

    moveMenuDisplay: state.notebook.protocolSection.scene.moveMenu?.display,
    moveMenuComponent: state.notebook.protocolSection.scene.moveMenu?.component,
    moveMenuType: state.notebook.protocolSection.scene.moveMenu?.type,
    moveMenuConnect: state.notebook.protocolSection.scene.moveMenu?.connect,
    notebookExpanded: !state.notebook.notebookCollapsed,
    focusedTask: state.notebook.protocolSection.scene.focusedTask,
    taskPage: state.notebook.protocolSection.scene.focusedPage,
    //description: getSlideDescription(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {

    setHeldObject: (data) => {
      dispatch(setHeldObject(data))
    },
    setHeld: (data) => {
      dispatch(setHeld(data))
    },
    setTargetList: (data) => {
      dispatch(setTargetList(data))
    },
    pushInteractions: (data) => {
      dispatch(pushInteractions(data))
    },
    setLastDrop: (data) => {
      dispatch(setLastDrop(data))
    },
    setSceneScale: (data) => {
      dispatch(setSceneScale(data))
    },
    setUserScale: (data) => {
      dispatch(setUserScale(data))
    },
    setupProtocolScene: (data) => {
      dispatch(setupProtocolScene(data))
    },
    setTaskPages: (data) => {
      dispatch(setTaskPages(data))
    },
    showMoveMenu: (data) => {
      dispatch(showMoveMenu(data))
    },
    setModal: (data) => {
      dispatch(setModal(data))
    },
  };
}

export const ProtocolView = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);

const getProtocolSection = ({notebook}) => notebook.protocolSection;
// const getSlideDescription = createSelector(
//   [getProtocolSection],
//   (protocolSection) => {
//     const currentSlide = fetchProtocolScene(
//       protocolSection.allSlides,
//       protocolSection.currentSlide
//     );
//     return currentSlide.description;
//   }
// );
